import { createFileRoute } from '@tanstack/react-router'
import WorkEditionsSection from 'Work/components/Work/Sections/Editions/WorkEditionsSection'

export const Route = createFileRoute('/work/$workId/productions')({
    component: WorkEditionsSection,
})
